import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-combined-heat-power-modal',
  imports: [MatDialogModule],
  templateUrl: './combined-heat-power-modal.html',
})
export class CombinedHeatPowerModal {
  dialog = inject(MatDialog);

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
